function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.98095 13.0693C7.01604 13.0693 6.22656 13.8588 6.22656 14.8237V18.3764C6.22656 19.3413 7.01604 20.1307 7.98095 20.1307C8.94587 20.1307 9.73535 19.3413 9.73535 18.3764V14.8237C9.73535 13.8588 8.9459 13.0693 7.98095 13.0693Z",
  fill: "white"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M14.3397 2.32384H10.9626C10.5678 1.05191 9.38364 0.130859 7.98009 0.130859C6.57655 0.130859 5.39237 1.05191 4.99764 2.32384H1.6643C1.18185 2.32384 0.787109 2.71858 0.787109 3.20103C0.787109 3.68349 1.18185 4.07823 1.6643 4.07823H5.0415C5.2608 4.82384 5.74325 5.43788 6.40115 5.83261C4.03272 6.53437 2.27834 8.72735 2.27834 11.3151V15.9203C2.27834 16.7098 2.93623 17.3677 3.72571 17.3677H4.90992V14.8677C4.90992 13.1571 6.31343 11.7537 8.02396 11.7537C9.73448 11.7537 11.138 13.1572 11.138 14.8677V17.3677H12.3222C13.1117 17.3677 13.7696 16.7098 13.7696 15.9203V11.3589C13.7696 8.77118 12.0152 6.53437 9.64673 5.87647C10.3046 5.48174 10.7871 4.8677 11.0064 4.12209H14.3836C14.866 4.12209 15.2608 3.72735 15.2608 3.24489C15.2169 2.71858 14.8222 2.32384 14.3397 2.32384ZM7.98009 4.99928C7.01518 4.99928 6.22571 4.20981 6.22571 3.24489C6.22571 2.27998 7.01518 1.49051 7.98009 1.49051C8.94501 1.49051 9.73448 2.27998 9.73448 3.24489C9.77834 4.20981 8.98887 4.99928 7.98009 4.99928Z",
  fill: "white"
});
function SvgDelivery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 21,
    viewBox: "0 0 16 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelivery);
export default __webpack_public_path__ + "static/media/delivery.a21ae0a1ca16fe995970cb687b38e2fa.svg";
export { ForwardRef as ReactComponent };